// Today at HHL (Texas): the one "today" for plans, BOM revisions in effect, and date defaults, the same in the
// browser and on the server. Never `new Date().toISOString().slice(0, 10)`: that's the UTC date, a day ahead every
// evening. No imports, so any shared module can use it without an import cycle.

export const PLAN_TIME_ZONE = "America/Chicago";

let dayFormat: Intl.DateTimeFormat | null = null;
/** Today at HHL, YYYY-MM-DD (or the day `now` falls on there). */
export function planToday(now: Date = new Date()): string {
  dayFormat ??= new Intl.DateTimeFormat("en-CA", { timeZone: PLAN_TIME_ZONE, year: "numeric", month: "2-digit", day: "2-digit" });
  return dayFormat.format(now);
}

/** `iso` plus `n` days (YYYY-MM-DD in, YYYY-MM-DD out; no time zones involved). */
export const addDays = (iso: string, n: number) => new Date(Date.parse(`${iso.slice(0, 10)}T00:00:00Z`) + n * 86_400_000).toISOString().slice(0, 10);
